module.exports = __webpack_public_path__ + "img/1.fdbae380.png";